import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "slide-bar"
};
var _hoisted_2 = {
  class: "navs"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 0,
  class: "tooltip"
};
var _hoisted_5 = ["src"];
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { appAliasEvent } from '@/utils/auth';
import { skipUrl as skipUrlOpen } from '@/util/util';
import slideAIImg from '@/assets/images/slide-ai-entry.png';
export default {
  __name: 'SlideBar',
  emits: ['change', 'back'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var SlideBNavs = [{
      name: '备',
      path: '/bei',
      iconName: 'slide-bei',
      exist: true
    }, {
      name: '教',
      path: '/jiao',
      iconName: 'slide-jiao',
      exist: true
    }, {
      name: '评',
      path: '/ping',
      iconName: 'slide-ping',
      exist: true
    }, {
      name: '改',
      path: '/gai',
      iconName: 'slide-gai',
      exist: true
    }, {
      name: '辅',
      path: '/fu',
      iconName: 'slide-fu',
      exist: true
    }, {
      name: '管',
      path: '/guan',
      iconName: 'slide-guan',
      exist: true
    }, {
      name: '研',
      path: '/yan',
      iconName: 'slide-yan',
      exist: false
    }];
    var _useRouter = useRouter(),
      currentRoute = _useRouter.currentRoute;
    var router = useRouter();
    var appUrl = ref('');
    var handleChange = function handleChange(item, index) {
      if (!item.exist) return;
      router.push("".concat(item.path));
      emit('change', item, index);
    };
    onMounted(function () {
      aiAliasEvent();
    });
    var aiAliasEvent = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return appAliasEvent('chatAi', false);
            case 1:
              appUrl.value = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function aiAliasEvent() {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleAiClick = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              skipUrlOpen(appUrl.value, '_blank');
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleAiClick() {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(SlideBNavs, function (item, index) {
        return _createElementVNode("li", {
          class: _normalizeClass(['nav-item', _unref(currentRoute).fullPath.includes(item.path) && 'is-active', !item.exist && 'is-disabled']),
          key: index,
          onClick: function onClick($event) {
            return handleChange(item, index);
          }
        }, [_createVNode(_component_svg_icon, {
          name: item.iconName,
          size: "32"
        }, null, 8, ["name"]), _createElementVNode("span", null, _toDisplayString(item.name), 1), !item.exist ? (_openBlock(), _createElementBlock("i", _hoisted_4, "敬请期待")) : _createCommentVNode("", true)], 10, _hoisted_3);
      }), 64))]), appUrl.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "ai",
        src: _unref(slideAIImg),
        alt: "",
        onClick: handleAiClick
      }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]);
    };
  }
};